import { render } from "./Aboutus.vue?vue&type=template&id=7db4572a&scoped=true"
import script from "./Aboutus.vue?vue&type=script&lang=js"
export * from "./Aboutus.vue?vue&type=script&lang=js"

import "./Aboutus.vue?vue&type=style&index=0&id=7db4572a&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Desktop/SILA/Web/phone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db4572a"]])

export default __exports__